module.exports = __webpack_public_path__ + "img/logo-white.127b3a7a.svg";